/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '@mui/material';

import { ClusterStates } from 'shared';

import { Namespaces } from '../../../../../../i18n';
import { useChangePlanButtonStyles } from './ChangePlanButton.styles';

type ChangePlanButtonProps = {
  clusterStatus: ClusterStates | undefined;
  onClick?: () => void;
  disabled?: boolean;
};

export function ChangePlanButton(props: ChangePlanButtonProps) {
  const { clusterStatus, onClick, disabled } = props;
  const { t } = useTranslation();
  const classes = useChangePlanButtonStyles();

  return (
    <Button
      classes={{ root: classes.link }}
      disabled={
        disabled ||
        clusterStatus === ClusterStates.Importing ||
        clusterStatus === ClusterStates.Updating ||
        clusterStatus === ClusterStates.Creating ||
        clusterStatus === ClusterStates.Unavailable ||
        clusterStatus === ClusterStates.Stopping ||
        clusterStatus === ClusterStates.Stopped
      }
      onClick={onClick}
      data-cy="cluster-page-change-plan-button"
    >
      {t(`${Namespaces.Cluster}:plan.change_plan`)}
    </Button>
  );
}
